import * as S from '@effect/schema/Schema';
export var FooterBlockConfig = S.struct({
  typename: S.literal('FooterBlock'),
  id: S.string,
  hash: S.string,
  influitiveLogo: S["boolean"],
  privacyPolicyLink: S.nullable(S.string),
  termsAndConditionsLink: S.nullable(S.string)
});